import DashboardIcon from "./rpm-v2/DashboardIcon";
import EcgIcon from "./rpm-v2/EcgIcon";
import FolderIcon from "./rpm-v2/FolderIcon";
import HeartIcon from "./rpm-v2/HeartIcon";
import HomeIcon from "./rpm-v2/HomeIcon";
import HopiIcon from "./rpm-v2/HopiIcon";
import PPFMIcon from "./rpm-v2/ppfm";
import NursingStaffIcon from "./rpm-v2/NursingStaffIcon";
import ObGynIcon from "./rpm-v2/ObGynIcon";
import PatientProfileIcon from "./rpm-v2/PatientProfileIcon";
import PrescriptionIcon from "./rpm-v2/PrescriptionIcon";
import ReportsIcon from "./rpm-v2/ReportsIcon";
import SpO2 from "./rpm-v2/SpO2";
import Thermometer from "./rpm-v2/Thermometer";
import VitalsIcon from "./rpm-v2/VitalsIcon";
import CircleIcon from "./rpm-v2/CircleIcon";
import ArrowDownIcon from "./rpm-v2/ArrowDownIcon";
import DownloadIcon from "./rpm-v2/DownloadIcon";
import Enlarge from "./rpm-v2/Enlarge";
import NurseIcon from "./rpm-v2/NurseIcon";
import LocationIcon from "./rpm-v2/LocationIcon";
import EditIcon from "./rpm-v2/EditIcon";
import EditSquare from "./rpm-v2/EditSquare";
import EyeIcon from "./rpm-v2/EyeIcon";
import ArrowRightIcon from "./rpm-v2/ArrowRightIcon";
import SearchIcon from "./rpm-v2/SearchIcon";
import PulseIcon from "./rpm-v2/PulseIcon";
import OxygenLevelIcon from "./rpm-v2/OxygenLevelIcon";
import TemperatureIcon from "./rpm-v2/TempratureIcon";
import PulseBlueIcon from "./rpm-v2/PulseBlueIcon";
import ListViewIcon from "./rpm-v2/ListViewIcon";
import GridViewIcon from "./rpm-v2/GridViewIcon";
import CarouselViewIcon from "./rpm-v2/CaraoselViewIcon";
import DigiSetuFullIcon from "./rpm-v2/DigisetuFullIcon";
import DigiSetuHalfIcon from "./rpm-v2/DigisetuHalfIcon";
import NoAppointmentVector from "./rpm-v2/NoAppointmentVector";
import IdeaBulbIcon from "./rpm-v2/IdeaBulbIcon";
import Cdss_icon from "./rpm-v2/CDSS";
import SettingsIcon from "./rpm-v2/Settings.icon";
import ProfileIcon from "./rpm-v2/Profile.icon";
import FaqIcon from "./rpm-v2/Faq.icon";
import LogoutIcon from "./rpm-v2/Logout.icon";
import HomeIcon_NavItem from "./materio-nav/HomeIcon";
import DiversityIcon from "./materio-nav/DiversityIcon";
import InfoIcon from "./rpm-v2/InfoIcon";
import BloodTestIcon from "./rpm-v2/BloodTestIcon";
import Glucose from "./rpm-v2/Glucose";
import UrineTestIcon from "./rpm-v2/UrineTestIcon";
import PregnancyIcon from "./rpm-v2/PregnancyIcon";
import PauseIcon from "./rpm-v2/PauseIcon";
import Stethscope from "./rpm-v2/Stethscope";
import MUACicon from "./rpm-v2/MUACicon";
import LiveIcon from "./rpm-v2/LiveIcon";
import PEIcon from "./rpm-v2/PEIcon";
import DropdownArrowDouble from "./rpm-v2/DropdownArrowDouble";
import HistoryIcon from "./rpm-v2/HistoryIcon";
import PulseOutlined from "./rpm-v2/vitals/PulseOutlined";
import { BookMarkIcon, BookMarkIconFilled } from "./rpm-v2/BookMarkIcon";
import OxygenOutlined from "./rpm-v2/vitals/OxygenOutlined";
import TemperatureOutlined from "./rpm-v2/vitals/TemperatureOutlined";
import GlucoseOutlined from "./rpm-v2/vitals/GlucoseOutlined";
import HemoglobinOutlined from "./rpm-v2/vitals/HemoglobinOutlined";
import VideoCall from "./rpm-v2/VideoCall";
import SmallCloseIconRound from "./rpm-v2/SmallCloseIconRound";
import Respirstory from "./rpm-v2/Respirstory";
import MedicalCentreIcon from "./rpm-v2/MedicalCentreIcon";
import OnlineCOnsultationIcon from "./rpm-v2/OnlineConsultationIcon";
import OnlineAndMedicalCentreCombinedIcon from "./rpm-v2/OnlineAndMedicalCentreCombinedIcon";
import SuccessIcon from "./rpm-v2/SuccessIcon";
import AddIconRound from "./rpm-v2/AddIconRound";
import DeleteIcon from "./rpm-v2/DeleteIcon";
import RefreshIcon from "./rpm-v2/RefreshIcon";
import PlayButton from "./rpm-v2/PlayButton";
import PauseButtonIcon from "./rpm-v2/PauseButtonIcon";
import PdfIcon from "./rpm-v2/PdfIcon";
import VisitIcon from "./rpm-v2/VisitIcon";
import CalendarIcon from "./rpm-v2/CalanderIcon";
import CloudIcon from "./rpm-v2/CloudIcon";
import SelectArrowIcon from "./rpm-v2/SelectArrowIcon";
import DownloadReportIcon from "./rpm-v2/DownloadReportIcon";
import HomeIconV2 from "./rpm-v2/HomeIconV2";
import SearchIconV2 from "./rpm-v2/SearchIconV2";

import NurseRoleIcon from "./rpm-v2/NurseRoleIcon";
import DoctorRoleIcon from "./rpm-v2/DoctorROleIcon";
import AdminRoleIcon from "./rpm-v2/AdminRoleIcon";
import UserPlaceholder from "./rpm-v2/UserPlaceholder";
import AddSquareIcon from "./rpm-v2/AddSquareIcon";
import AddUnitIcon from "./rpm-v2/AddUnitIcon";
import AddUnitOutlinedIcon from "./rpm-v2/AddUnitOutlinedIcon";
import { DoctorIcon } from "../Logos/Icons";
import CloseIconRaw from "./CloseIconRaw";
import HamburgerIcon from "./materio-nav/HamburgerIcon";
import LeftPanelClose from "./materio-nav/LeftPannelClose";
import CheckIcon from "./rpm-v2/CheckIcon";
import CancelIcon from "./rpm-v2/CancelIcon";
import { TeamIcon } from "./rpm-v2/Team.Icon";
import ProjectsIcon from "./rpm-v2/Projects";

import { HamburgerLight, HamburgerBold } from "./rpm-v2/HamburgerLight";
import {
  ChevronLeftBold,
  ChevronLeftLight,
  ChevronRightBold,
  ChevronRightLight,
} from "./rpm-v2/ChevronArrow";
import { ProjectIcon } from "./rpm-v2/Project.Icon";

export const SvgIcons = {
  RpmV2: {
    Home: HomeIcon,
    Folder: FolderIcon,
    VitalsIcon,
    CircleIcon,
    HopiIcon,
    PPFMIcon,
    Cdss_icon,
    ObGynIcon,
    PEIcon,
    ReportsIcon,
    PatientProfileIcon,
    NursingStaffIcon,
    PrescriptionIcon,
    DashboardIcon,
    Thermometer,
    SpO2,
    HeartIcon,
    EcgIcon,
    DownloadIcon,
    Enlarge,
    NurseIcon,
    LocationIcon,
    EditIcon,
    EditSquare,
    EyeIcon,
    BookMarkIcon,
    BookMarkIconFilled,
    SearchIcon,
    DownloadReportIcon,
    SettingsIcon,
    ProfileIcon,
    FaqIcon,
    LogoutIcon,
    InfoIcon,
    BloodTestIcon,
    Glucose,

    PauseIcon,
    UrineTestIcon,
    PregnancyIcon,
    Stethscope,
    MUACicon,
    LiveIcon,
    Respirstory,
    MedicalCentreIcon,
    OnlineCOnsultationIcon,
    OnlineAndMedicalCentreCombinedIcon,
    SuccessIcon,
    AddIconRound,
    DeleteIcon,
  },
  ArrowRightIcon,
  PulseIcon,
  OxygenLevelIcon,
  TemperatureIcon,
  PulseBlueIcon,
  ListViewIcon,
  GridViewIcon,
  CarouselViewIcon,
  FolderIcon,
  CircleIcon,
  ArrowDownIcon,
  DigiSetuFullIcon,
  DigiSetuHalfIcon,
  NoAppointmentVector,
  IdeaBulbIcon,
  HomeIcon_NavItem,
  DiversityIcon,
  BloodTestIcon,
  Glucose,
  PauseIcon,
  UrineTestIcon,
  PregnancyIcon,
  Stethscope,
  MUACicon,
  LiveIcon,
  DropdownArrowDouble,
  BookMarkIcon,
  BookMarkIconFilled,
  HistoryIcon,
  PulseOutlined,
  OxygenOutlined,
  TemperatureOutlined,
  GlucoseOutlined,
  HemoglobinOutlined,
  VideoCall,
  SmallCloseIconRound,
  Respirstory,
  MedicalCentreIcon,
  OnlineCOnsultationIcon,
  OnlineAndMedicalCentreCombinedIcon,
  SuccessIcon,
  AddIconRound,
  DeleteIcon,
  PlayButton,
  PauseButtonIcon,
  PdfIcon,
  CalendarIcon,
  VisitIcon,
  CloudIcon,
  SelectArrowIcon,
  UserPlaceholder,
  AddSquareIcon,
  AddUnitIcon,
  AddUnitOutlinedIcon,
  CalendarIcon,
  VisitIcon,
  DoctorIcon,
  CloudIcon,
  SelectArrowIcon,
  CloseIconRaw,
  NurseIcon,
  HamburgerIcon,
  LeftPanelClose,
  CheckIcon,
  CancelIcon,
  HomeIconV2,
  SearchIconV2,
  RefreshIcon,
  AdminRoleIcon,
  NurseRoleIcon,
  DoctorRoleIcon,
  TeamIcon,
  ProjectsIcon,
  HamburgerLight,
  HamburgerBold,
  ProjectIcon,
  ReportsIcon,
  ChevronLeftBold,
  ChevronLeftLight,
  ChevronRightBold,
  ChevronRightLight,
};
